import React from "react";
import {
  MdOutlineCorporateFare,
  MdOutlineHistoryToggleOff,
} from "react-icons/md";

function IntroduceUpdating({ title, language = "vi" }) {
  const isMilestone = /mốc|milestone/i.test(title);
  const copy = isMilestone
    ? {
        label: language === "vi" ? "HÀNH TRÌNH HSV" : "HSV JOURNEY",
        description:
          language === "vi"
            ? "Những dấu mốc nổi bật trong hành trình hình thành và phát triển của HSV."
            : "Key milestones throughout HSV's formation and development.",
      }
    : {
        label: language === "vi" ? "HỆ SINH THÁI DOANH NGHIỆP" : "CORPORATE ECOSYSTEM",
        description:
          language === "vi"
            ? "Thông tin các đơn vị thành viên trong hệ sinh thái HSV đang được hoàn thiện."
            : "Information about HSV member companies is being completed.",
      };

  return (
    <section
      className={`introduce-updating introduce-updating--${
        isMilestone ? "milestone" : "companies"
      }`}
      aria-live="polite"
    >
      <div className="introduce-updating__visual" aria-hidden="true">
        <span className="introduce-updating__ring introduce-updating__ring--outer" />
        <span className="introduce-updating__ring introduce-updating__ring--inner" />
        <span className="introduce-updating__icon">
          {isMilestone ? (
            <MdOutlineHistoryToggleOff />
          ) : (
            <MdOutlineCorporateFare />
          )}
        </span>
        <span className="introduce-updating__visual-orbit">
          <i />
        </span>
      </div>

      <div className="introduce-updating__body">
        <span className="introduce-updating__eyebrow">{copy.label}</span>
        <h1>{title}</h1>
        <p>{copy.description}</p>
        <div className="introduce-updating__status">
          <span aria-hidden="true" />
          {language === "vi" ? "Đang cập nhật dữ liệu" : "Content is being updated"}
        </div>
      </div>

      <div className="introduce-updating__progress" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </section>
  );
}

export default IntroduceUpdating;
